import styled from '@emotion/styled'
import { Box, Button, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 32px;
`

export const IconsContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 32px;
`

export const IconContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 254px;

  svg {
    height: 180px;
    margin-bottom: 8px;
  }
`

export const Label = styled(Typography)`
  text-align: center;
  color: ${colors.copy.paragraphDark};
  ${typography.baseline.regularSans};
`

export const Description = styled(Typography)`
  margin-bottom: 24px;
  color: ${colors.copy.paragraphDark};
  align-self: center;
  ${typography.baseline.regularSans};
`

export const StartButton = styled(Button)`
  align-self: flex-end;
  margin-top: 8px;
`
